import { Link } from "react-router-dom";
import {
    Tab,
    TabList,
    TabListProps,
    makeStyles,
    mergeClasses,
    shorthands,
} from "@fluentui/react-components";

import logo from '../cosme-widget-logo.png';
import { useContext, useEffect, useState } from "react";
import { Count } from "../library/CosmeWidgetAPIClient";
import { CWClientContext } from "../App";
import { UserProfile } from "./msal/UserProfile";


const useStyles = makeStyles({
    Logo: {
        height: "4vh",
        marginTop: "9px",
        marginBottom: "-9px",
    },
    Navigation: {
        ...shorthands.margin("6px"),
        ...shorthands.borderRadius("8px"),
        // boxShadow: getTheme().effects.elevation8,
    },
    Link: {
        color: "GrayText",
        textDecorationLine: "none",
    },
    profile: {
        ...shorthands.margin("18px"),
    },
    header: {
        display: "flex",
        boxShadow: "0px -5px 16px rgb(0 0 0 / 50%)",
        position: "relative",
        zIndex: "99",
        width: "calc(100% - 0px)",
        height: "70px",
    },
    logoarea: {
        width: "20vw",
        maxWidth: "20vw",
    },
    menuarea: {
        width: "65vw",
        maxWidth: "65vw",
    },
    profilearea: {
        width: "14vw",
        maxWidth: "14vw",
    },
});

type HeaderProps = {
    displayName: string;
    email: string;
    tabListProp: Partial<TabListProps>;
}

const Header = function (props: Partial<HeaderProps>) {
    const client = useContext(CWClientContext);
    const [numOfExtract, setNumOfExtract] = useState<Count>({ count: 0, label: "all" });

    useEffect(() => {
        (async () => {
            // TODO NONEは開発中のみ。
            let count = await client.getArchiveAllCount(['DETECTED']);
            setNumOfExtract(count);
        })();
    }, []);

    const styles = useStyles();
    return (
        <div className={mergeClasses(styles.header)}>
            <div className={styles.logoarea}>
                <a className="{styles.text}" href="/">
                    <img src={logo} alt="logo" className={styles.Logo} />
                </a>
                ver.{process.env.REACT_APP_VERSION}
            </div>
            <div className={styles.menuarea}>
                <TabList size="large" className={styles.Navigation}>

                    <Link className={styles.Link} to="/">
                        <Tab value="tabHome">HOME</Tab>
                    </Link>

                    <Link className={styles.Link} to="/extract/">
                        <Tab value="tabExtract">
                            抽出結果
                            {/* <CounterBadge
                                count={numOfExtract.count}
                                appearance="filled"
                            /> */}
                        </Tab>
                    </Link>

                    <Link className={styles.Link} to="/customer/">

                        <Tab value="tabCustomer">
                            顧客管理
                        </Tab>
                    </Link>
                    <Link className={styles.Link} to="/master/">
                        <Tab value="tabMaster">
                            元帳管理
                        </Tab>
                    </Link>
                    <Link className={styles.Link} to="/sitemap/">
                        <Tab value="tabSitemap">
                            サイトマップ管理
                        </Tab>
                    </Link>
                    <Link className={styles.Link} to="/widget/">
                        <Tab value="tabWidget">
                            ウィジット管理
                        </Tab>
                    </Link>
                    <Link className={styles.Link} to="/job/">
                        <Tab value="tabJob">
                            ジョブ
                        </Tab>
                    </Link>


                </TabList>
            </div>
            <div className={styles.profilearea}>
                <div
                    className={styles.profile}
                >
                    <UserProfile />
                </div>
            </div>
        </div>
    );
}

export default Header;